import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.PersonFilters;

// initial state
// object name must match specification name
const filters = {
	StateCode: new FormControl.FilterGroup('StateCode', 'Filter by State', 'All States', '', false, true, 'checkbox'),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };